import { createAction, props } from '@ngrx/store';

import { MyWorkPermit, MyWorkPermitDocumentFile } from '../../work-permits/work-permits.interfaces';

export const getMyWorkPermits = createAction('[My Work Permits] Get My Work Permits');
export const getMyWorkPermitsSuccess = createAction(
  '[My Work Permits] Get My Work Permits Success',
  props<{ myWorkPermits: MyWorkPermit[] }>()
);
export const getMyWorkPermitsError = createAction('[My Work Permits] Get My Work Permits Error');

export const getMyWorkPermit = createAction('[My Work Permits] Get My Work Permit', props<{ workPermitId: string }>());
export const getMyWorkPermitSuccess = createAction(
  '[My Work Permits] Get My Work Permit Success',
  props<{ myWorkPermit: MyWorkPermit }>()
);
export const getMyWorkPermitError = createAction(
  '[My Work Permits] Get My Work Permit Error',
  props<{ workPermitId: string }>()
);

export const uploadMyWorkPermitDocumentFile = createAction(
  '[My Work Permits] Upload Document File',
  props<{ uploadId: string; workPermitId: string; documentId: string; file: File }>()
);
export const uploadMyWorkPermitDocumentFileSuccess = createAction(
  '[My Work Permits] Upload Document File Success',
  props<{ uploadId: string; workPermitId: string; documentId: string }>()
);
export const uploadMyWorkPermitDocumentFileError = createAction(
  '[My Work Permits] Upload Document File Error',
  props<{ uploadId: string; workPermitId: string; documentId: string }>()
);

export const removeMyWorkPermitDocumentFile = createAction(
  '[My Work Permits] Remove Document File',
  props<{ workPermitId: string; documentId: string; file: MyWorkPermitDocumentFile }>()
);
export const removeMyWorkPermitDocumentFileSuccess = createAction(
  '[My Work Permits] Remove Document File Success',
  props<{ workPermitId: string; userAssetId: string }>()
);
export const removeMyWorkPermitDocumentFileError = createAction(
  '[My Work Permits] Remove Document File Error',
  props<{ userAssetId: string }>()
);
